
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { capitalizeSentence } from '../../filters'
import { EpbSelect } from '../shared/epb-select'
import { EpbTextbox } from '../shared/epb-textbox'

export default defineComponent({
  name: 'ConfigurationsSearchInput',
  components: {
    EpbSelect,
    EpbTextbox,
  },
  props: {
    tags: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    selectedTag: {
      type: String,
      default: '',
    },
    tagsLabel: String,
    queryLabel: String,
    queryPlaceholder: String,
    queryHelp: String,
    round: {
      type: Boolean,
      default: false,
    },
    showMaxLength: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      query: '',
    }
  },
  computed: {
    queryMaxLength(): number {
      if (this.showMaxLength) {
        return 80 - (!!this.selectedTag && this.selectedTag.length)
      }

      return undefined
    },
  },
  methods: {
    capitalizeSentence,
    onQueryChange(query: string): void {
      this.query = query
      this.$emit('queryChange', query)
    },
  },
})
